const DriverSearch = ({ searchQuery, handleSearchQuery, searchOwner, clearSearch }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-6xl mx-auto ml-0">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="flex flex-col">
          <label className="text-md font-medium mb-1 text-gray-700">Name</label>
          <input
            type="text"
            placeholder="Search by name"
            value={searchQuery.name || ""}
            onChange={(e) => handleSearchQuery("name", e.target.value)}
            className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="flex flex-col">
          <label className="text-md font-medium mb-1 text-gray-700">Mobile</label>
          <input
            type="number"
            placeholder="Search by mobile"
            value={searchQuery.mobile || ""}
            onChange={(e) => {
              let value = e.target.value;
              if (value.startsWith("88")) {
                value = value.slice(2);
              }
              const errorDiv =
                e.target.parentElement.querySelector(".error-message") || document.createElement("div");
              errorDiv.className = "error-message text-red-500 text-sm mt-1";

              if (value.length < 11 && value.length > 0) {
                errorDiv.textContent = "Phone number must be 11 digits";
              } else {
                errorDiv.textContent = "";
              }

              if (!e.target.parentElement.querySelector(".error-message")) {
                e.target.parentElement.appendChild(errorDiv);
              }

              if (/^[0-9]{0,11}$/.test(value)) {
                handleSearchQuery("mobile", value);
              }
            }}
            className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="flex flex-col">
          <label className="text-md font-medium mb-1 text-gray-700">Verification Status</label>
          <select
            name="verificationStatus"
            id="verificationStatus"
            className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => handleSearchQuery('isVerifiedAsDriver', e.target.value)}
            value={searchQuery.isVerifiedAsDriver || 'all'}
          >
            <option value="all">All Status</option>
            <option value="true">Verified</option>
            <option value="false">Not Verified</option>
          </select>
        </div>
      </div>
      <div className="flex items-center justify-between mt-4 space-x-3">
        <div className="flex flex-row gap-4">
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">Division</label>
            <select
              name="division"
              id="division"
              className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={(e) => handleSearchQuery('division', e.target.value)}
              value={searchQuery.division || 'all'}
            >
              <option value="all">All Divisions</option>
              <option value="Dhaka">Dhaka</option>
              <option value="Chattogram">Chattogram</option>
              <option value="Rajshahi">Rajshahi</option>
              <option value="Khulna">Khulna</option>
              <option value="Barishal">Barishal</option>
              <option value="Sylhet">Sylhet</option>
              <option value="Rangpur">Rangpur</option>
              <option value="Mymensingh">Mymensingh</option>
            </select>
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">From District</label>
            <input
              type="text"
              placeholder="District Name"
              className="border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onChange={(e) => handleSearchQuery('fromDistrict', e.target.value)}
              value={searchQuery.fromDistrict || ''}
            />
          </div>
        </div>
        <div className="flex gap-4 h-11 mt-5">
          <button
            className="px-5 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-all"
            onClick={clearSearch}
          >
            Clear
          </button>
          <button
            className="px-5 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-all"
            onClick={searchOwner}
            onKeyDown={(e) => e.key === "Enter" && searchOwner()}
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default DriverSearch;
